__turbopack_context__.v({
  "aboutUsButtonRow": "Patients-module-scss-module__btjmLq__aboutUsButtonRow",
  "aboutUsContainer": "Patients-module-scss-module__btjmLq__aboutUsContainer",
  "aboutUsImage": "Patients-module-scss-module__btjmLq__aboutUsImage",
  "aboutUsParagraphs": "Patients-module-scss-module__btjmLq__aboutUsParagraphs",
  "aboutUsText": "Patients-module-scss-module__btjmLq__aboutUsText",
  "aboutUsTitle": "Patients-module-scss-module__btjmLq__aboutUsTitle",
  "active": "Patients-module-scss-module__btjmLq__active",
  "adaptiveFlexAlign": "Patients-module-scss-module__btjmLq__adaptiveFlexAlign",
  "adaptiveSectionElevenTextAlign": "Patients-module-scss-module__btjmLq__adaptiveSectionElevenTextAlign",
  "adaptiveSectionSixTextAlign": "Patients-module-scss-module__btjmLq__adaptiveSectionSixTextAlign",
  "adaptiveTextAlign": "Patients-module-scss-module__btjmLq__adaptiveTextAlign",
  "adaptiveTitleSize": "Patients-module-scss-module__btjmLq__adaptiveTitleSize",
  "advantageCardsContainer": "Patients-module-scss-module__btjmLq__advantageCardsContainer",
  "advisorGrid": "Patients-module-scss-module__btjmLq__advisorGrid",
  "advisorSection": "Patients-module-scss-module__btjmLq__advisorSection",
  "arrowDown": "Patients-module-scss-module__btjmLq__arrowDown",
  "arrowRight": "Patients-module-scss-module__btjmLq__arrowRight",
  "awardContainer": "Patients-module-scss-module__btjmLq__awardContainer",
  "awardImageContainer": "Patients-module-scss-module__btjmLq__awardImageContainer",
  "awardName": "Patients-module-scss-module__btjmLq__awardName",
  "awardPrice": "Patients-module-scss-module__btjmLq__awardPrice",
  "beforeAfterLabel": "Patients-module-scss-module__btjmLq__beforeAfterLabel",
  "bigRow": "Patients-module-scss-module__btjmLq__bigRow",
  "box": "Patients-module-scss-module__btjmLq__box",
  "certIconGroup": "Patients-module-scss-module__btjmLq__certIconGroup",
  "certText": "Patients-module-scss-module__btjmLq__certText",
  "certificationBanner": "Patients-module-scss-module__btjmLq__certificationBanner",
  "col": "Patients-module-scss-module__btjmLq__col",
  "constrainWidth": "Patients-module-scss-module__btjmLq__constrainWidth",
  "contactSection": "Patients-module-scss-module__btjmLq__contactSection",
  "contentMaxWidth": "Patients-module-scss-module__btjmLq__contentMaxWidth",
  "designError": "Patients-module-scss-module__btjmLq__designError",
  "diseaseElementsContainer": "Patients-module-scss-module__btjmLq__diseaseElementsContainer",
  "diseaseTitle": "Patients-module-scss-module__btjmLq__diseaseTitle",
  "diseasesContainer": "Patients-module-scss-module__btjmLq__diseasesContainer",
  "doctorContainer": "Patients-module-scss-module__btjmLq__doctorContainer",
  "doctorContent": "Patients-module-scss-module__btjmLq__doctorContent",
  "doctorExplanationTitle": "Patients-module-scss-module__btjmLq__doctorExplanationTitle",
  "doctorSection": "Patients-module-scss-module__btjmLq__doctorSection",
  "doctorsExplanationBody": "Patients-module-scss-module__btjmLq__doctorsExplanationBody",
  "doctorsImage": "Patients-module-scss-module__btjmLq__doctorsImage",
  "drawer": "Patients-module-scss-module__btjmLq__drawer",
  "drawerTopBar": "Patients-module-scss-module__btjmLq__drawerTopBar",
  "expContainer": "Patients-module-scss-module__btjmLq__expContainer",
  "expImage": "Patients-module-scss-module__btjmLq__expImage",
  "expText": "Patients-module-scss-module__btjmLq__expText",
  "expTitle": "Patients-module-scss-module__btjmLq__expTitle",
  "explanationImage": "Patients-module-scss-module__btjmLq__explanationImage",
  "explanationSection": "Patients-module-scss-module__btjmLq__explanationSection",
  "explanationText": "Patients-module-scss-module__btjmLq__explanationText",
  "explanationTitle": "Patients-module-scss-module__btjmLq__explanationTitle",
  "flwr": "Patients-module-scss-module__btjmLq__flwr",
  "footer": "Patients-module-scss-module__btjmLq__footer",
  "footerBottom": "Patients-module-scss-module__btjmLq__footerBottom",
  "footerCopyright": "Patients-module-scss-module__btjmLq__footerCopyright",
  "footerGroup": "Patients-module-scss-module__btjmLq__footerGroup",
  "footerLink": "Patients-module-scss-module__btjmLq__footerLink",
  "footerLinks": "Patients-module-scss-module__btjmLq__footerLinks",
  "imageWrapper": "Patients-module-scss-module__btjmLq__imageWrapper",
  "innerModal": "Patients-module-scss-module__btjmLq__innerModal",
  "investorImage": "Patients-module-scss-module__btjmLq__investorImage",
  "itemsCenter": "Patients-module-scss-module__btjmLq__itemsCenter",
  "justifyCenter": "Patients-module-scss-module__btjmLq__justifyCenter",
  "lighttherapyFlex": "Patients-module-scss-module__btjmLq__lighttherapyFlex",
  "lighttherapyFlexDoctor": "Patients-module-scss-module__btjmLq__lighttherapyFlexDoctor",
  "link": "Patients-module-scss-module__btjmLq__link",
  "listItem": "Patients-module-scss-module__btjmLq__listItem",
  "main": "Patients-module-scss-module__btjmLq__main",
  "marginBig": "Patients-module-scss-module__btjmLq__marginBig",
  "marginBottomBigScreen": "Patients-module-scss-module__btjmLq__marginBottomBigScreen",
  "marginBottomSmallScreen": "Patients-module-scss-module__btjmLq__marginBottomSmallScreen",
  "marginMiddle": "Patients-module-scss-module__btjmLq__marginMiddle",
  "marginSmall": "Patients-module-scss-module__btjmLq__marginSmall",
  "modal": "Patients-module-scss-module__btjmLq__modal",
  "networkContainerDirection": "Patients-module-scss-module__btjmLq__networkContainerDirection",
  "networkContent": "Patients-module-scss-module__btjmLq__networkContent",
  "networkSection": "Patients-module-scss-module__btjmLq__networkSection",
  "orderProcessStep": "Patients-module-scss-module__btjmLq__orderProcessStep",
  "pRegularFontSize": "Patients-module-scss-module__btjmLq__pRegularFontSize",
  "partnerButtonPosition": "Patients-module-scss-module__btjmLq__partnerButtonPosition",
  "partnerImageContainer": "Patients-module-scss-module__btjmLq__partnerImageContainer",
  "patientBody": "Patients-module-scss-module__btjmLq__patientBody",
  "patientContainer": "Patients-module-scss-module__btjmLq__patientContainer",
  "patientContent": "Patients-module-scss-module__btjmLq__patientContent",
  "patientTitle": "Patients-module-scss-module__btjmLq__patientTitle",
  "processContainer": "Patients-module-scss-module__btjmLq__processContainer",
  "processSteps": "Patients-module-scss-module__btjmLq__processSteps",
  "processTitle": "Patients-module-scss-module__btjmLq__processTitle",
  "proximaNova": "Patients-module-scss-module__btjmLq__proximaNova",
  "root": "Patients-module-scss-module__btjmLq__root",
  "row": "Patients-module-scss-module__btjmLq__row",
  "secondArrowRight": "Patients-module-scss-module__btjmLq__secondArrowRight",
  "sectionEight": "Patients-module-scss-module__btjmLq__sectionEight",
  "sectionEleven": "Patients-module-scss-module__btjmLq__sectionEleven",
  "sectionFive": "Patients-module-scss-module__btjmLq__sectionFive",
  "sectionFiveMarginBottom": "Patients-module-scss-module__btjmLq__sectionFiveMarginBottom",
  "sectionFour": "Patients-module-scss-module__btjmLq__sectionFour",
  "sectionMedium": "Patients-module-scss-module__btjmLq__sectionMedium",
  "sectionSeven": "Patients-module-scss-module__btjmLq__sectionSeven",
  "sectionSix": "Patients-module-scss-module__btjmLq__sectionSix",
  "sectionThreePatient": "Patients-module-scss-module__btjmLq__sectionThreePatient",
  "sectionThreeTitle": "Patients-module-scss-module__btjmLq__sectionThreeTitle",
  "sectionTwo": "Patients-module-scss-module__btjmLq__sectionTwo",
  "sectionTwoTitle": "Patients-module-scss-module__btjmLq__sectionTwoTitle",
  "sizeExperiment": "Patients-module-scss-module__btjmLq__sizeExperiment",
  "smallImageCol": "Patients-module-scss-module__btjmLq__smallImageCol",
  "smallImageContainer": "Patients-module-scss-module__btjmLq__smallImageContainer",
  "spaceAround": "Patients-module-scss-module__btjmLq__spaceAround",
  "spaceBetween": "Patients-module-scss-module__btjmLq__spaceBetween",
  "studyContainerDirection": "Patients-module-scss-module__btjmLq__studyContainerDirection",
  "studyContent": "Patients-module-scss-module__btjmLq__studyContent",
  "studyImageMargin": "Patients-module-scss-module__btjmLq__studyImageMargin",
  "tabletArrow": "Patients-module-scss-module__btjmLq__tabletArrow",
  "teamContainer": "Patients-module-scss-module__btjmLq__teamContainer",
  "teamGrid": "Patients-module-scss-module__btjmLq__teamGrid",
  "teamSection": "Patients-module-scss-module__btjmLq__teamSection",
  "textCenter": "Patients-module-scss-module__btjmLq__textCenter",
  "therapySetContainer": "Patients-module-scss-module__btjmLq__therapySetContainer",
  "therapySetContent": "Patients-module-scss-module__btjmLq__therapySetContent",
  "therapySetImage": "Patients-module-scss-module__btjmLq__therapySetImage",
  "therapySetText": "Patients-module-scss-module__btjmLq__therapySetText",
  "therapySetTitle": "Patients-module-scss-module__btjmLq__therapySetTitle",
  "threeLineEllipse": "Patients-module-scss-module__btjmLq__threeLineEllipse",
  "wideBox": "Patients-module-scss-module__btjmLq__wideBox",
  "womanOnChairImage": "Patients-module-scss-module__btjmLq__womanOnChairImage",
  "youtubeEmbed": "Patients-module-scss-module__btjmLq__youtubeEmbed",
  "youtubeEmbedContainer": "Patients-module-scss-module__btjmLq__youtubeEmbedContainer",
});
